import React, { Dispatch, SetStateAction } from 'react';
import {
  Autocomplete,
  Checkbox,
  Grid2,
  ListItem,
  TextField,
  Typography,
} from '@mui/material';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { InputField } from '../FormFields';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;
interface UserData {
  username: string;
  reports: string[];
  roles: string[];
  email: string;
  firstName: string;
  lastName: string;
}
// TODO:// Figure out if we will ever have more roles, need to get roles from a source
const RolesData = ['admin', 'manager', 'Expo User'];
interface UpdateUserProps {
  foundUser: UserData;
  reportsSelected: string[];
  setReportsSelected: Dispatch<SetStateAction<string[]>>;
  rolesSelected: string[];
  setRolesSelected: Dispatch<SetStateAction<string[]>>;
  reportList: string[];
}
const UpdateUser = (props: UpdateUserProps) => {
  const {
    foundUser: { username, email, firstName, lastName },
    reportsSelected,
    setReportsSelected,
    rolesSelected,
    setRolesSelected,
    reportList,
  } = props;

  return (
    <>
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{ marginBottom: 2 }}
      >
        Current User: {username}
      </Typography>
      <Grid2
        container
        spacing={3}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Autocomplete
            multiple
            options={reportList}
            disableCloseOnSelect
            value={reportsSelected}
            onChange={(event, value) => setReportsSelected(value)}
            getOptionLabel={(option: string) => option}
            renderOption={(renderprops, option, { selected }) => {
              return (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <li {...renderprops}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    sx={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...params}
                autoComplete="new-password"
                label="Assigned Reports"
                placeholder="Report Name"
              />
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Autocomplete
            multiple
            options={RolesData}
            disableCloseOnSelect
            onChange={(event, value) => setRolesSelected(value)}
            value={rolesSelected}
            getOptionLabel={(option: string) => option}
            renderOption={(renderprops, option, { selected }) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <ListItem {...renderprops}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  sx={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </ListItem>
            )}
            renderInput={(params) => (
              <TextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...params}
                autoComplete="new-password"
                label="Assigned Roles"
                placeholder="Role"
              />
            )}
          />
        </Grid2>

        <Grid2 size={{ xs: 12 }} sx={{ marginTop: 2 }}>
          <Typography variant="h6" align="center" color="red">
            Fill Below only if you want to Update User&apos;s Information
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6 }}>
          <TextField
            disabled
            id="outlined-disabled"
            label="Current First Name"
            defaultValue={firstName}
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="firstName"
            label="New First Name"
            textFieldType="text"
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <TextField
            disabled
            id="outlined-disabled"
            label="Current Last Name"
            defaultValue={lastName}
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="lastName"
            label="New Last Name"
            textFieldType="text"
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <TextField
            disabled
            id="outlined-disabled"
            label="Current Email"
            defaultValue={email}
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="email"
            label="New Email"
            textFieldType="text"
            fullWidth
          />
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="password"
            label="Update User's Password"
            textFieldType="password"
            fullWidth
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="confirmPassword"
            label="Confirm New Password"
            textFieldType="password"
            fullWidth
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default UpdateUser;
